import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'The Secret',
  slug: 'the-secret',
  category: 'The Secret',
  date: '2025-05-16',
  image: '',
  excerpt: 'I fixed every problem in my life with this one little secret!',
  body: `I fixed every problem in my life with this one little secret!

There are no hidden secrets to anything; just a lack of commitment to finding the answers.

— Chris Canis

Chris is a friend and fellow business consultant and life coach. He and I come from different places (he's a Marine sergeant and I'm an artist) and have different approaches (he's a Marine sergeant and I'm an artist). But we agree on this concept. And it's frustrating to see other coaches pretend they have the secret.

We both believe in the power of work. And the power of having a partner to get through the bumps in the road.

If you could use a direct, disciplined approach to help you break down some ingrained patterns, Chris would be a great guy to work with. Oh, and he has plenty of business background as well.`,
}

export default post
